export default __webpack_public_path__ + "static/media/web tasarım-01.2412825d.png";